/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UserModel} from "../../models/UserModel";
import {AuthService} from "../../providers/auth-service";

/**
 * Generated class for the SignupForm component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'signup-form',
  templateUrl: 'signup-form.html'
})
export class SignupForm implements OnInit {

  user: UserModel = new UserModel(null, null, null, null, UserModel.TYPE_SPECTATOR);
  userPassword: string;

  errorMessage: string;

  accountTypes: string[] = [];

  @Output()
  onCreateRequest: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  accountCreated: EventEmitter<string> = new EventEmitter();

  @Output()
  signupError: EventEmitter<string> = new EventEmitter();

  // signupForm: FormGroup;

  constructor(private authService: AuthService) {

  }

  // toggleMode() {
  //   this.ui.showYesNoPrompt('Confirm Cencel',
  //     'Are you sure you want to cancel creating an account and go back to the login screen?',
  //     () => {
  //     // do nothing
  //   }, () => {
  //       this.onCreateRequest.next(false);
  //     });
  // }

  createAccount() {
    this.authService.createAccount(this.user, this.userPassword).then((res) => {
      if (res) {
        this.accountCreated.next(res);
      }
    }, err => {
      console.warn('got error');
      console.error(err);
      this.errorMessage = err;
      this.signupError.emit(err);
    });
  }

  ngOnInit(): void {
    this.accountTypes[UserModel.TYPE_SPECTATOR] = 'Spectator';
    this.accountTypes[UserModel.TYPE_DANCE_PARENT] = 'Dance Parent';
    this.accountTypes[UserModel.TYPE_TEACHER] = 'Teacher';
    this.accountTypes[UserModel.TYPE_DANCER] = 'Dancer';
    this.accountTypes[UserModel.TYPE_OTHER] = 'Other';
  }

  onPasswordResult($event: string) {
    this.userPassword = $event;
  }
}



// WEBPACK FOOTER //
// ./src/components/signup-form/signup-form.ts